import React from "react";
import helpers from "../../common/utils/utils";

export const getTitleDetails = (result) => {
  const value = result?.gene_info?.[0]?.url || result?.variant_info?.[0]?.url;
  const pharmGKBLink = (
    <div className="tw-inline-flex tw-items-center tw-float-right">
      <a href={value} target="_blank">
        View in PharmGKB
      </a>
    </div>
  );
  return value ? pharmGKBLink : null;
};

export function PharmGKBTitles(
  clinicalAnnotationsTable,
  guidelinesTable,
  chemicalRelationsTable,
  drugLabelAnnotationsTable,
  diseaseRelationsTable
) {
  return (
    <div className="varsome-inner-container">
      {clinicalAnnotationsTable && (
        <div className="tw-mb-10">
          <h5>Clinical Annotations</h5>
          {clinicalAnnotationsTable}
        </div>
      )}
      {guidelinesTable && (
        <div className="tw-mb-10">
          <h5>Guidelines</h5>
          {guidelinesTable}
        </div>
      )}
      {chemicalRelationsTable && (
        <div className="tw-mb-10">
          <h5>Chemical Relations</h5>
          {chemicalRelationsTable}
        </div>
      )}
      {drugLabelAnnotationsTable && (
        <div className="tw-mb-10">
          <h5>Drug Label Annotations</h5>
          {drugLabelAnnotationsTable}
        </div>
      )}
      {diseaseRelationsTable && (
        <div className="tw-mb-10">
          <h5>Disease Relations</h5>
          {diseaseRelationsTable}
        </div>
      )}
    </div>
  );
}

export const sortByLatestUpdate = (arr) => {
  return arr.sort((a, b) => {
    if (a.latest_update > b.latest_update) {
      return -1;
    }
    if (a.latest_update < b.latest_update) {
      return 1;
    }
    return 0;
  });
};

export const extractdrugLabelAnnotationsItems = (arr) => {
  return arr.filter((item) => {
    return (
      item.drug_label_annotations != null ||
      (item.drug_label_annotations && item.drug_label_annotations.length > 0)
    );
  });
};

export const sortByCuratorNotes = (arr) => {
  return arr.concat().sort((left, right) => {
    if (left.hasOwnProperty("curator_notes")) {
      return -1;
    }
    if (right.hasOwnProperty("curator_notes")) {
      return 1;
    }
    return 0;
  });
};

export const diseaseUrl = "https://www.pharmgkb.org/disease/";
export const chemicalUrl = "https://www.pharmgkb.org/chemical/";
export const drugLabelAnnotationUrl =
  "https://www.pharmgkb.org/labelAnnotation/";
export const guidelineAnnotationUrl =
  "https://www.pharmgkb.org/guidelineAnnotation/";
export const url = "https://www.pharmgkb.org";

export const prepareDiseaseRelationsItems = (items) => {
  if (!items) {
    return null;
  }
  return items.map((x, i) => {
    const pDynamic =
      x.pharmacodynamic !== undefined &&
      x.pharmacodynamic !== null &&
      (x.pharmacodynamic ? "Yes" : "No");
    const pKinetic =
      x.pharmacokinetic !== undefined &&
      x.pharmacokinetic !== null &&
      (x.pharmacokinetic ? "Yes" : "No");
    return {
      ...x,
      association:
        x.association &&
        helpers.capitalizeFirstLetter(x.association.toLowerCase()),
      pharmacodynamic: pDynamic,
      pharmacokinetic: pKinetic,
      name: x.name && helpers.capitalizeFirstLetter(x.name.toLowerCase()),
      diseaseNameIdUrl: diseaseUrl + x.id,
      key: `${i}${new Date()}`,
    };
  });
};

export const prepareDrugLabelAnnotationsItems = (items) => {
  return items.map((x, i) => {
    const pDynamic =
      x.pharmacodynamic !== undefined &&
      x.pharmacodynamic !== null &&
      (x.pharmacodynamic ? "Yes" : "No");
    const pKinetic =
      x.pharmacokinetic !== undefined &&
      x.pharmacokinetic !== null &&
      (x.pharmacokinetic ? "Yes" : "No");
    const labelAnnotations = x.drug_label_annotations.map((y, z) => {
      return {
        ...y,
        name: y.name && helpers.capitalizeFirstLetter(y.name.toLowerCase()),
        drugLabelNameIdUrl: drugLabelAnnotationUrl + y.id,
        key: `${z}${new Date()}`,
      };
    });
    return {
      ...x,
      drug_label_annotations: labelAnnotations,
      pharmacodynamic: pDynamic,
      pharmacokinetic: pKinetic,
      name: x.name && helpers.capitalizeFirstLetter(x.name.toLowerCase()),
      drugNameIdUrl: chemicalUrl + x.id,
      key: `${i}${new Date()}`,
    };
  });
};

export const prepareGuidelinesItems = (items) => {
  return items.map((x, i) => {
    const rec =
      x.recommended !== undefined &&
      x.recommended !== null &&
      (x.recommended ? "Yes" : "No");
    const chemicalRelations = x.chemical_relations.map((y, z) => {
      return {
        ...y,
        name: y.name && helpers.capitalizeFirstLetter(y.name.toLowerCase()),
        chemicalUrl: chemicalUrl + y.id,
        key: `${z}${new Date()}`,
      };
    });
    return {
      ...x,
      chemical_relations: chemicalRelations,
      recommended: rec,
      name: x.name && helpers.capitalizeFirstLetter(x.name.toLowerCase()),
      guidelineUrl: guidelineAnnotationUrl + x.id,
      key: `${i}${new Date()}`,
    };
  });
};
